import ro from './languages/ro.js'
import en from './languages/en.js'
import de from './languages/de.js'
import hu from './languages/hu.js'
import sr from './languages/sr.js'
import ru from './languages/ru.js'
import tr from './languages/tr.js'
import bg from './languages/bg.js'
import pl from './languages/pl.js'
import ua from './languages/ua.js'

const messages = {
    ro: ro,
    en: en,
    de: de,
    hu: hu,
    sr: sr,
    ru: ru,
    tr: tr,
    bg: bg,
    pl: pl,
    ua: ua
};

export default messages;
